import { render } from "./TrendPointChartField.vue?vue&type=template&id=2af4cf04&scoped=true"
import script from "./TrendPointChartField.vue?vue&type=script&lang=js"
export * from "./TrendPointChartField.vue?vue&type=script&lang=js"

import "./TrendPointChartField.vue?vue&type=style&index=0&id=2af4cf04&scoped=true&lang=css"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af4cf04"],['__file',"TrendPointChartField.vue"]])

export default __exports__